/* eslint-disable react/prefer-stateless-function */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { IntlProvider } from 'react-intl';
import Routes from './routes';
import { actions as localeActions } from './redux/ducks/locale';
import { actions as loginActions } from './redux/ducks/login';
import { actions as changePasswordActions } from './redux/ducks/change-password';
import { actions as tcActions } from './redux/ducks/terms-and-conditions';
import { getLocale } from './util/locale';

export const App = (props) => {
  const getLocale = (locale) => {
    switch (locale) {
      case 'en_GB':
      case 'en_CA':
        return 'en_US';
      case 'es_US':
      case 'es_ES':
        return 'es_AR';
      case 'in_ID':
        return 'id_ID';
      case 'it_CH':
        return 'it_IT';
      case 'ro_MO':
        return 'ro_RO';
      default:
        return locale;
    }
  };
  const [messages, setMessages] = useState({});
  const { history, locale, rightToLeftLangCodes } = props;

  useEffect(() => {
    const localeLabel = getLocale(locale);
    try {
      const labelsContext = require.context('../../src/locales', false, /labels_.*\.json$/);
      // Dynamically load the JSON file based on the localeLabel
      const message = labelsContext(`./labels_${localeLabel}.json`);
      setMessages(message.default || message); // Access the default export
    } catch (error) {
      console.error(`Failed to load labels for locale ${localeLabel}:`, error);
    }
    if (rightToLeftLangCodes && 
      rightToLeftLangCodes.length > 0 && 
      rightToLeftLangCodes.includes(locale)) {
      document.getElementsByTagName('html')[0].setAttribute("dir", 'rtl');
    } else {
      document.getElementsByTagName('html')[0].setAttribute("dir", 'ltr');
    }
  }, [locale]);

  return (
    <IntlProvider messages={ messages }>
      <ConnectedRouter history={ history }>
        <Routes { ...props } />
      </ConnectedRouter>
    </IntlProvider>
  );
};

App.propTypes = {
  history: PropTypes.objectOf(PropTypes.any),
  locale: PropTypes.string,
};

const mapStateToProps = ({
  locale,
  login,
  brand,
  signin,
  sendingRequest,
  changepassword,
  termsandconditions,
}) => ({
  ...locale,
  ...login,
  ...brand,
  ...signin,
  ...sendingRequest,
  ...changepassword,
  ...termsandconditions,
});

const mapDispatchToProps = dispatch => bindActionCreators(
    Object.assign(
      {},
      { ...localeActions },
      { ...loginActions },
      { ...changePasswordActions },
      { ...tcActions },
    ),
    dispatch,
  );
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(App);
